<script setup>
defineEmits(['update:modelValue', 'blur'])

const props = defineProps({
  modelValue: { type: [String, Number], default: null },
  selectId: { type: String, default: null },
  placeholder: { type: String, default: 'Sélectionner une option' },
  options: { type: Array, required: true },
  size: { type: String, default: 'md', validator: (s) => ['md', 'lg'].includes(s) },
  disabled: { type: Boolean, default: false },
  error: { type: Boolean, default: null },
  success: { type: Boolean, default: null },
  selectClass: { type: String, default: '' },
  required: { type: Boolean, default: false },
  ariaDescribedby: { type: String, default: null },
  ariaErrormessage: { type: String, default: null },
})

const groupedOptions = computed(() => {
  return props.options.reduce((acc, option) => {
    const groupKey = option.group || 'none'
    if (!acc[groupKey]) {
      acc[groupKey] = []
    }
    acc[groupKey].push(option)
    return acc
  }, {})
})
</script>

<template>
  <div class="w-full relative">
    <select
      :id="selectId"
      :value="modelValue"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :aria-describedby="ariaDescribedby"
      :aria-invalid="error"
      :aria-errormessage="ariaErrormessage"
      :class="[
        'border-none rounded-t initial:w-full h-full truncate bg-[#EEEEEE] focus:shadow-[inset_0_-2px_0_0_#3A3A3A] text-[#3a3a3a]',
        {
          'cursor-not-allowed shadow-[inset_0_-2px_0_0_#E5E5E5]': disabled,
          'shadow-[inset_0_-2px_0_0_#3A3A3A]': !disabled,
        },
        {
          '!shadow-[inset_0_-2px_0_0_#18753c]': success,
          '!shadow-[inset_0_-2px_0_0_#ce0500]': error,
        },
        { 'py-3': size === 'lg' },
        selectClass,
      ]"
      @input="$emit('update:modelValue', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
    >
      <option value="" :selected="!modelValue" :disabled="required">{{ placeholder }}</option>
      <template v-for="(groupOptions, groupName) in groupedOptions" :key="groupName">
        <optgroup v-if="groupName !== 'none'" :label="groupName">
          <option
            v-for="option in groupOptions"
            :key="option.key"
            :value="option.key"
            :disabled="option.disabled"
            :selected="modelValue === option.key"
          >
            {{ option.label }}
          </option>
        </optgroup>

        <template v-else>
          <option
            v-for="option in groupOptions"
            :key="option.key"
            :value="option.key"
            :disabled="option.disabled"
            :selected="modelValue === option.key"
          >
            {{ option.label }}
          </option>
        </template>
      </template>
    </select>
  </div>
</template>

<style lang="postcss" scoped>
select {
  --tw-ring-shadow: 0 0 #000 !important;
}
</style>
